export const greaterThanNow = (dateValue: string | number | Date): boolean => {
  return new Date(dateValue) > new Date()
}

export function setCookie (name: string, value: string, expDate: Date): void {
  document.cookie = `${name}=${value};expires=${expDate.toUTCString()};path=/`
}

export function getCookie (name: string): string {
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}

export const getConfig = (orchestrationServiceUrl: string, token?: string) => {
  const cfg: { baseURL: string, headers: Record<string, string> } = {
    baseURL: orchestrationServiceUrl,
    headers: {}
  }

  if (token) {
    cfg.headers.Authorization = token
  }

  return cfg
}

export async function sleep (ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}
